<template>
  <div class="function-indicators">
    <div v-if="!isLoading" class="function-indicators__wrapper">
      <div v-for="indicator in form.indicators" class="function-indicators__item row" :key="indicator.id">
        <div class="col col-10 col-md-10 col-xl-10">
          <c-input
            v-model="indicator.value"
            type="select"
            floating-label="Показатель"
            :searchable="true"
            :clearable="true"
            :items="collections.indicators"
          />
        </div>
        <div class="function-indicators__item-actions col col-2 col-md-2 col-xl-2">
          <c-button
            v-b-popover.hover.blur.top="'Удалить'"
            class="function-indicators__item-remove"
            :icon="{ icon: 'trash', color: 'secondary' }"
            size="iconic"
            @click="deleteIndicator(indicator.id)"
          />
          <c-button
            v-if="indicator && indicator.value && indicator.value.hasDescription"
            class="function-indicators__item-description"
            v-b-popover.html="{
              container: '#app',
              trigger: 'click blur',
              boundary: 'window',
              content: 'Показать описание',
              placement: 'top',
            }"
            size="iconic"
            icon="info-new"
            @click="showDescription(indicator)"
          />
        </div>
      </div>
      <p v-if="!form.indicators.length" class="function-indicators__empty">Показателей пока не добавлено</p>
      <div class="row">
        <div class="col col-xl-12 col-md-12 col-12">
          <c-button
            :responsive="true"
            size="small"
            label="Добавить показатель"
            :icon="{ icon: 'plus', color: 'primary' }"
            @click="addIndicator"
            :disabled="addIndicatorIsDisabled"
          />
        </div>
      </div>

      <div class="function__actions" :class="{'function__actions--fixed': actionsIsFixed}">
        <c-button class="function__action" label="Отменить" size="large" @click="onReset" />
        <c-button class="function__action" label="Сохранить" size="large" color="primary" @click="onSubmit" />
      </div>
    </div>

    <c-loader
      v-if="isLoading"
      label="Данные загружаются"
      :active="isLoading"
      height="400"
    />

    <m-description ref="descriptionModal" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import CButton from "@/components/controls2/Button";
import CInput from "@/components/controls2/Input";
import ResponsiveApplyResetActions from "@/components/responsive-apply-reset-actions";
import draggable from "vuedraggable";
import Loader from "@/components/loader";
import MDescription from "./components//description-modal";
import { getFileName, getFileType } from "@/utils/files";

export default {
  name: "function-indicators",

  components: {
    "c-button": CButton,
    "c-input": CInput,
    "c-loader": Loader,
    draggable,
    ResponsiveApplyResetActions,
    MDescription,
  },

  async created() {
    this.isLoading = true;

    await this.$store.dispatch("functions/getIndicatorsList").then((res) => {
      res.forEach(group => {
        this.collections.indicators.push({
          value: 'group-' + group.id,
          label: group.name,
          formatLabel: `<b>${group.name}</b>`,
          isGroup: true,
          disabled: true,
        })

        if (group.categories && group.categories.length) {
          group.categories.forEach(category => {
            this.collections.indicators.push({
              value: 'category-' + category.id,
              label: category.name,
              formatLabel: `<span style="padding-left: 10px;">${category.name}</span>`,
              isGroup: true,
              disabled: true,
            })

            if (category.items.length) {
              category.items.forEach(item => {
                this.collections.indicators.push({
                  value: item.id,
                  label: item.name,
                  formatLabel: `<span style="padding-left: 20px;">${item.name}</span>`,
                  resultLabel: `<b>${group.name} /</b> <b>${category.name}</b> / ${item.name}`,
                  isGroup: false,
                  description: item.description || "",
                  link: item.link || "",
                  files: item.files || "",
                  hasDescription: item.description || item.link || (item.files && item.files.length)
                })
              })
            }
          })
        }

        if (group.items.length) {
          group.items.forEach(item => {
            this.collections.indicators.push({
              value: item.id,
              label: item.name,
              formatLabel: `<span style="padding-left: 10px;">${item.name}</span>`,
              resultLabel: `<b>${group.name} /</b> ${item.name}`,
              isGroup: false,
              description: item.description || "",
              link: item.link || "",
              files: item.files || "",
              hasDescription: item.description || item.link || (item.files && item.files.length)
            })
          })
        }
      })
    })

    this.setIndicatorsFromFunctionModel();

    let flag = true;

    let interval = setInterval(() => {
      if (flag) {
        let layoutHeader = document.querySelector('.function .layout-header');
        let layoutSubheader = document.querySelector('.function .subheader');
        let functionContent = document.querySelector('.function .function__content');
        
        let sumContentHeight = layoutHeader.scrollHeight + layoutSubheader.scrollHeight + functionContent.scrollHeight

        if (functionContent) {
          if (sumContentHeight + 50 > document.documentElement.clientHeight) {
            setTimeout(() => {
              this.actionsIsFixed = true
            }, 500);
            
            flag = false;
            clearInterval(interval)
          } else {
            this.actionsIsFixed = false
          }
        }
      }
    }, 100);

    this.isLoading = false;
  },

  data() {
    return {
      isLoading: false,
      indicatorsIdsCounter: 0,
      actionsIsFixed: false,

      form: {
        indicators: [],
      },

      collections: {
        indicators: [],
      }
    }
  },
  computed: {
    ...mapState({
      functionModel: (state) => state.functions.functionModel,
    }),
    addIndicatorIsDisabled() {
      let disabled = false;

      if (this.form.indicators.length) {
        disabled = true;

        if (this.form.indicators[this.form.indicators.length -1].value) disabled = false
      }

      return disabled
    },
  },
  methods: {
    addIndicator() {
      this.form.indicators.push({id: this.indicatorsIdsCounter, value: "", description: ""})
      this.indicatorsIdsCounter++
    },
    deleteIndicator(indicatorId) {
      this.form.indicators = this.form.indicators.filter(indicator => indicator.id !== indicatorId);
    },
    showDescription(indicator) {
      let value = indicator.value;

      let data = {
        name: value.label,
        description: value.description,
        link: value.link,
        files: value.files,
      };

      data.files = data.files.map(({ id, name }) => ({
        id,
        name: getFileName(name),
        type: getFileType(name),
        url: name,
      }));

      this.$refs.descriptionModal.open(data);
    },
    async onSubmit() {
      let params = {
        page: "indicators",
        id: this.functionModel.id,
        indicators: this.form.indicators.filter(indicator => indicator.value)
      }

      await this.$store.dispatch("functions/updateFunction", params).then(res => {
        if (res.success) {
          this.$notify({
            group: "success-message",
            data: {
              textMessage: `Показатели для функции успешно сохранены`,
            },
          });
        } else {
          Vue.notify({
            group: "error-message",
            data: {
              textMessage: `Произошла ошибка. Попробуйте ещё раз`,
            },
          });
        }
      })
    },
    onReset() {
      this.setIndicatorsFromFunctionModel();
    },
    setIndicatorsFromFunctionModel() {
      this.form.indicators = [];

      if (this.functionModel.indicators && this.functionModel.indicators.length) {
        this.functionModel.indicators.forEach(indicator => {
          let findedIndicator = this.collections.indicators.find(indicatorInCollection => Number(indicatorInCollection.value) === Number(indicator.id));
          if (findedIndicator) {
            this.form.indicators.push({id: this.indicatorsIdsCounter, value: findedIndicator })
            this.indicatorsIdsCounter++
          }
        })
      }
    }
  },
  watch: {
    functionModel: {
      handler() {
        this.setIndicatorsFromFunctionModel();
      },
      deep: true
    },
    "form.indicators": {
      handler() {
        this.collections.indicators.forEach(indicator => {
          if (!indicator.isGroup) {
            let findedIndicator = this.form.indicators.find(indicatorInForm => indicatorInForm.value.value === indicator.value)

            if (findedIndicator) {
              indicator.disabled = true;
            } else {
              indicator.disabled = false;
            }
          }
        })
      },
      deep: true
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.function-indicators {
  padding-top: 36px;
  .row {
    margin-bottom: 25px;
  }

  &__empty {
    color: #8E9CBB;
    line-height: 100%;
  }

  &__item {
    display: flex;
    align-items: center;

    &-actions {
      display: flex;
      align-items: center;
    }

    &-description {
      transform: translate(-50%, -50%);
      margin-left: 15px;
    }
  }
}
</style>